"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgArrowCircleSide(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.626 0 12 5.374 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C0 5.373 5.372 0 12 0zm0 1.532C6.218 1.532 1.532 6.219 1.532 12c0 5.782 4.686 10.468 10.468 10.468 5.78 0 10.468-4.686 10.468-10.468C22.468 6.22 17.78 1.532 12 1.532zm-1.5 6.863a.766.766 0 01.073.997l-.074.086-1.756 1.756h8.363a.766.766 0 01.104 1.525l-.104.007-8.364-.001 1.757 1.757a.766.766 0 01.074.998l-.074.085a.766.766 0 01-.997.075l-.086-.075-3.064-3.063-.065-.074a.769.769 0 01-.005-.007l.07.08A.77.77 0 016.128 12v-.03a.77.77 0 01.003-.046L6.128 12a.77.77 0 01.224-.542l3.064-3.063c.299-.3.784-.3 1.083 0z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgArrowCircleSide;
exports.default = _default;